// Base
import { BaseApi } from '../base.api'

// Interface
import { ITukWebpageApi, ITukWebpageApiRequest, ITukWebpageApiResponse, ITukWebpageGetAttrs } from 'interfaces/webpage/tuk'

// Constant
import { ApiConstant } from 'constant'
import { axios_renderUrl } from 'utils'

export class TukWebpageApi extends BaseApi<ITukWebpageApi> implements ITukWebpageApiRequest {
  readonly url = ApiConstant.TUK_URL
  private tukUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get tuk webpage
   *
   * @method POST
   * @url /tuk
   * @access public
   *
   * @return {Promise<ITukWebpageApiResponse>} Promise<ITukWebpageApiResponse>
   */
  async tukWebpage_getTuk(payload: ITukWebpageGetAttrs): Promise<ITukWebpageApiResponse> {
    try {
      const response = await this.POST(this.tukUrl, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
